'use client'

import { Clinical } from 'components/Phantom/_pageCompositions/Clinical'

export const ScienceContent = () => {
	return <Clinical />
}
